import script from "./FamilyGroupAddOtherModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupAddOtherModal.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupAddOtherModal.vue?vue&type=style&index=0&id=28a3e420&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a3e420"]])

export default __exports__